import type { useActIndicatorModel } from '@/components/home/components/act-indicator/act-indicator.model'

type ActIndicatorViewProps = ReturnType<typeof useActIndicatorModel>

export function ActIndicatorView({
  actLabel,
  positionText,
  ariaLabel,
  isVisible,
}: ActIndicatorViewProps) {
  return (
    <div
      className={`fz-act-indicator${isVisible ? ' fz-act-indicator--visible' : ''}`}
      role="status"
      aria-live="polite"
      aria-label={ariaLabel}
    >
      <span className="fz-act-indicator__label">{actLabel}</span>
      <span className="fz-act-indicator__sep" aria-hidden="true">
        ·
      </span>
      <span className="fz-act-indicator__position">{positionText}</span>
    </div>
  )
}
